import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { Button, ButtonProps, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useProjectFormContext } from "../contexts/ProjectFormContext"

export interface ProjectFormDetailsButtonProps extends ButtonProps {}

export const ProjectFormDetailsButton = React.memo(
  ({
    className,
    disabled,
    onClick,
    ...rest
  }: ProjectFormDetailsButtonProps) => {
    const { t } = useTranslation()
    const { isLoading, isDisabled, model } = useProjectFormContext()

    const handleClick =
      onClick ?? model?.core.handlers.onShowDetails ?? undefined

    return (
      <Button
        className={classNames("project-form__details-button", className)}
        disabled={disabled || isLoading || isDisabled}
        {...rest}
        onClick={handleClick}
        variant={ButtonVariant.TERTIARY}
        icon={IconName.ZOOM_IN}
        isIconOnly
        aria-label={t("Project.Actions.ShowDetails")}
      />
    )
  }
)

ProjectFormDetailsButton.displayName = "ProjectFormDetailsButton"
